// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AbandonHouseMapObjectsMapObjectIdAbandonPostData, AbandonHouseMapObjectsMapObjectIdAbandonPostErrors, AbandonHouseMapObjectsMapObjectIdAbandonPostResponses, ActivateUserItemUserInventoryUserItemIdActivatePostData, ActivateUserItemUserInventoryUserItemIdActivatePostErrors, ActivateUserItemUserInventoryUserItemIdActivatePostResponses, AdminCompleteElectionAdminElectionsCompletePostData, AdminCompleteElectionAdminElectionsCompletePostErrors, AdminCompleteElectionAdminElectionsCompletePostResponses, AdminRemoveMayorAdminElectionsRemoveMayorPostData, AdminRemoveMayorAdminElectionsRemoveMayorPostErrors, AdminRemoveMayorAdminElectionsRemoveMayorPostResponses, AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutData, AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutErrors, AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutResponses, AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutData, AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutErrors, AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutResponses, ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutData, ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutErrors, ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutResponses, AssignAndGetAllQuestsUserQuestsAssignAndGetGetData, AssignAndGetAllQuestsUserQuestsAssignAndGetGetErrors, AssignAndGetAllQuestsUserQuestsAssignAndGetGetResponses, AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetData, AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetErrors, AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetResponses, AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetData, AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetErrors, AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetResponses, AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetData, AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetErrors, AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetResponses, BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostData, BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostErrors, BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostResponses, BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostData, BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostErrors, BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostResponses, BuyMapObjectMapObjectsMapObjectIdBuyPostData, BuyMapObjectMapObjectsMapObjectIdBuyPostErrors, BuyMapObjectMapObjectsMapObjectIdBuyPostResponses, BuyShopItemShopBuyShopItemIdPostData, BuyShopItemShopBuyShopItemIdPostErrors, BuyShopItemShopBuyShopItemIdPostResponses, CancelListingMarketplaceCancelPostData, CancelListingMarketplaceCancelPostErrors, CancelListingMarketplaceCancelPostResponses, CheckUserPartnerCheckUserPostData, CheckUserPartnerCheckUserPostErrors, CheckUserPartnerCheckUserPostResponses, ClaimDailyRewardEndpointDailyRewardsClaimPostData, ClaimDailyRewardEndpointDailyRewardsClaimPostErrors, ClaimDailyRewardEndpointDailyRewardsClaimPostResponses, ClaimOnboardingRewardUserClaimOnboardingRewardPostData, ClaimOnboardingRewardUserClaimOnboardingRewardPostErrors, ClaimOnboardingRewardUserClaimOnboardingRewardPostResponses, ClaimQuestRewardUserQuestsClaimRewardPostData, ClaimQuestRewardUserQuestsClaimRewardPostErrors, ClaimQuestRewardUserQuestsClaimRewardPostResponses, ComebackDeclineUserComebackDeclinePostData, ComebackDeclineUserComebackDeclinePostErrors, ComebackDeclineUserComebackDeclinePostResponses, ComebackReplayUserComebackReplayPostData, ComebackReplayUserComebackReplayPostErrors, ComebackReplayUserComebackReplayPostResponses, CreateInvoiceTelegramCreateInvoicePostData, CreateInvoiceTelegramCreateInvoicePostErrors, CreateInvoiceTelegramCreateInvoicePostResponses, CreatePlotAdminPlotsPostData, CreatePlotAdminPlotsPostErrors, CreatePlotAdminPlotsPostResponses, CreateUserActionUserActionsCreatePostData, CreateUserActionUserActionsCreatePostErrors, CreateUserActionUserActionsCreatePostResponses, DebugTaskadLogDebugTaskadLogPostData, DebugTaskadLogDebugTaskadLogPostErrors, DebugTaskadLogDebugTaskadLogPostResponses, DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteData, DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteErrors, DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteResponses, DeleteMapObjectAdminMapObjectsMapObjectIdDeleteData, DeleteMapObjectAdminMapObjectsMapObjectIdDeleteErrors, DeleteMapObjectAdminMapObjectsMapObjectIdDeleteResponses, DeleteUserOnboardingStateUserOnboardingStateDeleteData, DeleteUserOnboardingStateUserOnboardingStateDeleteErrors, DeleteUserOnboardingStateUserOnboardingStateDeleteResponses, DeleteUserPopupStateUserPopupStateDeleteData, DeleteUserPopupStateUserPopupStateDeleteErrors, DeleteUserPopupStateUserPopupStateDeleteResponses, DismissElectionDialogElectionsDismissDialogPostData, DismissElectionDialogElectionsDismissDialogPostErrors, DismissElectionDialogElectionsDismissDialogPostResponses, DuelFinishDuelFinishPostData, DuelFinishDuelFinishPostErrors, DuelFinishDuelFinishPostResponses, DuelStartDuelStartPostData, DuelStartDuelStartPostErrors, DuelStartDuelStartPostResponses, DuelStatsDuelStatsGetData, DuelStatsDuelStatsGetErrors, DuelStatsDuelStatsGetResponses, EstimateGasMarketplaceEstimateGasGetData, EstimateGasMarketplaceEstimateGasGetErrors, EstimateGasMarketplaceEstimateGasGetResponses, FireflyAckEndpointDebugFireflyAckPostData, FireflyAckEndpointDebugFireflyAckPostErrors, FireflyAckEndpointDebugFireflyAckPostResponses, FireflyStateEndpointDebugFireflyStateGetData, FireflyStateEndpointDebugFireflyStateGetErrors, FireflyStateEndpointDebugFireflyStateGetResponses, GetAllMapObjectsMapObjectsGetData, GetAllMapObjectsMapObjectsGetErrors, GetAllMapObjectsMapObjectsGetResponses, GetBalancesMarketplaceMyBalancesGetData, GetBalancesMarketplaceMyBalancesGetErrors, GetBalancesMarketplaceMyBalancesGetResponses, GetCityhallStateCityhallStateGetData, GetCityhallStateCityhallStateGetErrors, GetCityhallStateCityhallStateGetResponses, GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetData, GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetErrors, GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetResponses, GetCursorUserInfoCursorUserInfoTgUserIdGetData, GetCursorUserInfoCursorUserInfoTgUserIdGetErrors, GetCursorUserInfoCursorUserInfoTgUserIdGetResponses, GetDailyRewardsStatusEndpointDailyRewardsStatusGetData, GetDailyRewardsStatusEndpointDailyRewardsStatusGetErrors, GetDailyRewardsStatusEndpointDailyRewardsStatusGetResponses, GetFurnitureCatalogFurnitureCatalogGetData, GetFurnitureCatalogFurnitureCatalogGetErrors, GetFurnitureCatalogFurnitureCatalogGetResponses, GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetData, GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetErrors, GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetResponses, GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetData, GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetErrors, GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetResponses, GetListingForHouseMarketplaceListingMapObjectIdGetData, GetListingForHouseMarketplaceListingMapObjectIdGetErrors, GetListingForHouseMarketplaceListingMapObjectIdGetResponses, GetListingsMarketplaceListingsGetData, GetListingsMarketplaceListingsGetResponses, GetMapObjectTypesAdminMapObjectsTypesGetData, GetMapObjectTypesAdminMapObjectsTypesGetErrors, GetMapObjectTypesAdminMapObjectsTypesGetResponses, GetMayorElectionsMayorGetData, GetMayorElectionsMayorGetErrors, GetMayorElectionsMayorGetResponses, GetQuestProgressQuestsGetProgressPostData, GetQuestProgressQuestsGetProgressPostErrors, GetQuestProgressQuestsGetProgressPostResponses, GetRateMarketplaceRateGetData, GetRateMarketplaceRateGetResponses, GetRealEstateCatalogRealEstateGetData, GetRealEstateCatalogRealEstateGetErrors, GetRealEstateCatalogRealEstateGetResponses, GetReferralInfoReferralInfoGetData, GetReferralInfoReferralInfoGetErrors, GetReferralInfoReferralInfoGetResponses, GetReferralStatsReferralStatsGetData, GetReferralStatsReferralStatsGetErrors, GetReferralStatsReferralStatsGetResponses, GetShopItemsShopItemsGetData, GetShopItemsShopItemsGetErrors, GetShopItemsShopItemsGetResponses, GetTop100Top100GetData, GetTop100Top100GetErrors, GetTop100Top100GetResponses, GetUserElectionDialogStateUserElectionDialogGetData, GetUserElectionDialogStateUserElectionDialogGetErrors, GetUserElectionDialogStateUserElectionDialogGetResponses, GetUserInventoryUserInventoryGetData, GetUserInventoryUserInventoryGetErrors, GetUserInventoryUserInventoryGetResponses, GetUserOnboardingStateUserOnboardingStateGetData, GetUserOnboardingStateUserOnboardingStateGetErrors, GetUserOnboardingStateUserOnboardingStateGetResponses, GetUserPopupStateUserPopupStateGetData, GetUserPopupStateUserPopupStateGetErrors, GetUserPopupStateUserPopupStateGetResponses, GetUserPublicCalculateUserGetData, GetUserPublicCalculateUserGetErrors, GetUserPublicCalculateUserGetResponses, ListHouseMarketplaceListPostData, ListHouseMarketplaceListPostErrors, ListHouseMarketplaceListPostResponses, MayorGreetingMayorGreetingPostData, MayorGreetingMayorGreetingPostErrors, MayorGreetingMayorGreetingPostResponses, MayorHistoryMayorHistoryGetData, MayorHistoryMayorHistoryGetErrors, MayorHistoryMayorHistoryGetResponses, MayorReplyMayorReplyPostData, MayorReplyMayorReplyPostErrors, MayorReplyMayorReplyPostResponses, PatchUserOnboardingStateUserOnboardingStatePatchData, PatchUserOnboardingStateUserOnboardingStatePatchErrors, PatchUserOnboardingStateUserOnboardingStatePatchResponses, PatchUserPopupStateUserPopupStatePatchData, PatchUserPopupStateUserPopupStatePatchErrors, PatchUserPopupStateUserPopupStatePatchResponses, PingPingGetData, PingPingGetErrors, PingPingGetResponses, PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostData, PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostErrors, PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostResponses, ProxyAvatarProxyAvatarGetData, ProxyAvatarProxyAvatarGetErrors, ProxyAvatarProxyAvatarGetResponses, RegisterCandidateElectionsRegisterPostData, RegisterCandidateElectionsRegisterPostErrors, RegisterCandidateElectionsRegisterPostResponses, RequestWithdrawMarketplaceWithdrawPostData, RequestWithdrawMarketplaceWithdrawPostErrors, RequestWithdrawMarketplaceWithdrawPostResponses, ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostData, ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostErrors, ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostResponses, SaveWalletMarketplaceSaveWalletPostData, SaveWalletMarketplaceSaveWalletPostErrors, SaveWalletMarketplaceSaveWalletPostResponses, TapTapPostData, TapTapPostErrors, TapTapPostResponses, TelegramWebhookTelegramWebhookPostData, TelegramWebhookTelegramWebhookPostErrors, TelegramWebhookTelegramWebhookPostResponses, ToggleLikeMapObjectsMapObjectIdToggleLikePostData, ToggleLikeMapObjectsMapObjectIdToggleLikePostErrors, ToggleLikeMapObjectsMapObjectIdToggleLikePostResponses, TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostData, TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostErrors, TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostResponses, TriggerErrorSentryCheckGetData, TriggerErrorSentryCheckGetResponses, UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostData, UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostErrors, UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostResponses, UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutData, UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutErrors, UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutResponses, UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutData, UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutErrors, UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutResponses, UpdateMapObjectAdminMapObjectsMapObjectIdPutData, UpdateMapObjectAdminMapObjectsMapObjectIdPutErrors, UpdateMapObjectAdminMapObjectsMapObjectIdPutResponses, VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostData, VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostErrors, VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostResponses, VerifyNotificationsUserNotificationsVerifyPostData, VerifyNotificationsUserNotificationsVerifyPostErrors, VerifyNotificationsUserNotificationsVerifyPostResponses, VoteAdForCandidateElectionsVoteAdPostData, VoteAdForCandidateElectionsVoteAdPostErrors, VoteAdForCandidateElectionsVoteAdPostResponses, VoteForCandidateElectionsVotePostData, VoteForCandidateElectionsVotePostErrors, VoteForCandidateElectionsVotePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Duel Start
 *
 * Start a Ghost Duel: reserve a ghost from pool or generate a phantom.
 *
 * Returns ghost_tap_count, ghost_replay_data, ghost_user info, and duel_id.
 */
export const duelStartDuelStartPost = <ThrowOnError extends boolean = false>(options?: Options<DuelStartDuelStartPostData, ThrowOnError>): RequestResult<DuelStartDuelStartPostResponses, DuelStartDuelStartPostErrors, ThrowOnError> => (options?.client ?? client).post<DuelStartDuelStartPostResponses, DuelStartDuelStartPostErrors, ThrowOnError>({ url: '/duel/start', ...options });

/**
 * Duel Finish
 *
 * Finish a Ghost Duel: submit player replay, compute outcome, update pool.
 */
export const duelFinishDuelFinishPost = <ThrowOnError extends boolean = false>(options: Options<DuelFinishDuelFinishPostData, ThrowOnError>): RequestResult<DuelFinishDuelFinishPostResponses, DuelFinishDuelFinishPostErrors, ThrowOnError> => (options.client ?? client).post<DuelFinishDuelFinishPostResponses, DuelFinishDuelFinishPostErrors, ThrowOnError>({
    url: '/duel/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duel Stats
 *
 * Get the current player's Ghost Duel statistics.
 */
export const duelStatsDuelStatsGet = <ThrowOnError extends boolean = false>(options?: Options<DuelStatsDuelStatsGetData, ThrowOnError>): RequestResult<DuelStatsDuelStatsGetResponses, DuelStatsDuelStatsGetErrors, ThrowOnError> => (options?.client ?? client).get<DuelStatsDuelStatsGetResponses, DuelStatsDuelStatsGetErrors, ThrowOnError>({ url: '/duel/stats', ...options });

/**
 * Get Daily Rewards Status Endpoint
 *
 * Get status of all daily reward days for user.
 *
 * Returns information about which days are available, claimed, and can be claimed.
 */
export const getDailyRewardsStatusEndpointDailyRewardsStatusGet = <ThrowOnError extends boolean = false>(options?: Options<GetDailyRewardsStatusEndpointDailyRewardsStatusGetData, ThrowOnError>): RequestResult<GetDailyRewardsStatusEndpointDailyRewardsStatusGetResponses, GetDailyRewardsStatusEndpointDailyRewardsStatusGetErrors, ThrowOnError> => (options?.client ?? client).get<GetDailyRewardsStatusEndpointDailyRewardsStatusGetResponses, GetDailyRewardsStatusEndpointDailyRewardsStatusGetErrors, ThrowOnError>({ url: '/daily-rewards/status', ...options });

/**
 * Claim Daily Reward Endpoint
 *
 * Claim daily reward for specific day.
 *
 * Args:
 * request: Request with day (1-7) to claim
 *
 * Returns user_item_id if successful, or null if day already claimed, not available, or error occurred.
 * Frontend should show popup if user_item_id is not null, otherwise do nothing.
 */
export const claimDailyRewardEndpointDailyRewardsClaimPost = <ThrowOnError extends boolean = false>(options: Options<ClaimDailyRewardEndpointDailyRewardsClaimPostData, ThrowOnError>): RequestResult<ClaimDailyRewardEndpointDailyRewardsClaimPostResponses, ClaimDailyRewardEndpointDailyRewardsClaimPostErrors, ThrowOnError> => (options.client ?? client).post<ClaimDailyRewardEndpointDailyRewardsClaimPostResponses, ClaimDailyRewardEndpointDailyRewardsClaimPostErrors, ThrowOnError>({
    url: '/daily-rewards/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Top 100
 *
 * Get top-100 players by different metrics.
 *
 * Returns five rankings, each containing up to 100 players:
 * - Top-100 by total taps (total_taps)
 * - Top-100 by currency balance (currency)
 * - Top-100 by real estate ownership count (number of houses)
 * - Top-100 by level (level, calculated based on exp)
 * - Top-100 by donations (sum of Telegram Stars donations)
 *
 * Each ranking contains player information: user_id, first_name, last_name, username, photo_url, value, and level.
 * Each ranking also contains current_player with the requesting user's position and data.
 */
export const getTop100Top100Get = <ThrowOnError extends boolean = false>(options?: Options<GetTop100Top100GetData, ThrowOnError>): RequestResult<GetTop100Top100GetResponses, GetTop100Top100GetErrors, ThrowOnError> => (options?.client ?? client).get<GetTop100Top100GetResponses, GetTop100Top100GetErrors, ThrowOnError>({ url: '/top-100', ...options });

/**
 * Get Cityhall State
 *
 * Отримати стан Мерії та виборів.
 */
export const getCityhallStateCityhallStateGet = <ThrowOnError extends boolean = false>(options?: Options<GetCityhallStateCityhallStateGetData, ThrowOnError>): RequestResult<GetCityhallStateCityhallStateGetResponses, GetCityhallStateCityhallStateGetErrors, ThrowOnError> => (options?.client ?? client).get<GetCityhallStateCityhallStateGetResponses, GetCityhallStateCityhallStateGetErrors, ThrowOnError>({ url: '/cityhall/state', ...options });

/**
 * Dismiss Election Dialog
 *
 * Mark election dialog as shown for today (per-user, server-side).
 */
export const dismissElectionDialogElectionsDismissDialogPost = <ThrowOnError extends boolean = false>(options?: Options<DismissElectionDialogElectionsDismissDialogPostData, ThrowOnError>): RequestResult<DismissElectionDialogElectionsDismissDialogPostResponses, DismissElectionDialogElectionsDismissDialogPostErrors, ThrowOnError> => (options?.client ?? client).post<DismissElectionDialogElectionsDismissDialogPostResponses, DismissElectionDialogElectionsDismissDialogPostErrors, ThrowOnError>({ url: '/elections/dismiss-dialog', ...options });

/**
 * Register Candidate
 */
export const registerCandidateElectionsRegisterPost = <ThrowOnError extends boolean = false>(options: Options<RegisterCandidateElectionsRegisterPostData, ThrowOnError>): RequestResult<RegisterCandidateElectionsRegisterPostResponses, RegisterCandidateElectionsRegisterPostErrors, ThrowOnError> => (options.client ?? client).post<RegisterCandidateElectionsRegisterPostResponses, RegisterCandidateElectionsRegisterPostErrors, ThrowOnError>({
    url: '/elections/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Vote For Candidate
 */
export const voteForCandidateElectionsVotePost = <ThrowOnError extends boolean = false>(options: Options<VoteForCandidateElectionsVotePostData, ThrowOnError>): RequestResult<VoteForCandidateElectionsVotePostResponses, VoteForCandidateElectionsVotePostErrors, ThrowOnError> => (options.client ?? client).post<VoteForCandidateElectionsVotePostResponses, VoteForCandidateElectionsVotePostErrors, ThrowOnError>({
    url: '/elections/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Vote Ad For Candidate
 *
 * Cast 5 free votes after watching an ad. 30 min cooldown per user per candidate.
 */
export const voteAdForCandidateElectionsVoteAdPost = <ThrowOnError extends boolean = false>(options: Options<VoteAdForCandidateElectionsVoteAdPostData, ThrowOnError>): RequestResult<VoteAdForCandidateElectionsVoteAdPostResponses, VoteAdForCandidateElectionsVoteAdPostErrors, ThrowOnError> => (options.client ?? client).post<VoteAdForCandidateElectionsVoteAdPostResponses, VoteAdForCandidateElectionsVoteAdPostErrors, ThrowOnError>({
    url: '/elections/vote-ad',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Mayor
 *
 * Отримати дані про чинного мера.
 */
export const getMayorElectionsMayorGet = <ThrowOnError extends boolean = false>(options?: Options<GetMayorElectionsMayorGetData, ThrowOnError>): RequestResult<GetMayorElectionsMayorGetResponses, GetMayorElectionsMayorGetErrors, ThrowOnError> => (options?.client ?? client).get<GetMayorElectionsMayorGetResponses, GetMayorElectionsMayorGetErrors, ThrowOnError>({ url: '/elections/mayor', ...options });

/**
 * Mayor Greeting
 *
 * Start a new conversation with the Mayor. Creates talk_to_mayor action for quest tracking.
 */
export const mayorGreetingMayorGreetingPost = <ThrowOnError extends boolean = false>(options?: Options<MayorGreetingMayorGreetingPostData, ThrowOnError>): RequestResult<MayorGreetingMayorGreetingPostResponses, MayorGreetingMayorGreetingPostErrors, ThrowOnError> => (options?.client ?? client).post<MayorGreetingMayorGreetingPostResponses, MayorGreetingMayorGreetingPostErrors, ThrowOnError>({ url: '/mayor/greeting', ...options });

/**
 * Mayor Reply
 *
 * Continue conversation with the Mayor.
 */
export const mayorReplyMayorReplyPost = <ThrowOnError extends boolean = false>(options: Options<MayorReplyMayorReplyPostData, ThrowOnError>): RequestResult<MayorReplyMayorReplyPostResponses, MayorReplyMayorReplyPostErrors, ThrowOnError> => (options.client ?? client).post<MayorReplyMayorReplyPostResponses, MayorReplyMayorReplyPostErrors, ThrowOnError>({
    url: '/mayor/reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mayor History
 *
 * Load recent conversation history with the Mayor.
 */
export const mayorHistoryMayorHistoryGet = <ThrowOnError extends boolean = false>(options?: Options<MayorHistoryMayorHistoryGetData, ThrowOnError>): RequestResult<MayorHistoryMayorHistoryGetResponses, MayorHistoryMayorHistoryGetErrors, ThrowOnError> => (options?.client ?? client).get<MayorHistoryMayorHistoryGetResponses, MayorHistoryMayorHistoryGetErrors, ThrowOnError>({ url: '/mayor/history', ...options });

/**
 * Get Shop Items
 *
 * Отримати всі товари в магазині з підвантаженими даними предметів.
 */
export const getShopItemsShopItemsGet = <ThrowOnError extends boolean = false>(options?: Options<GetShopItemsShopItemsGetData, ThrowOnError>): RequestResult<GetShopItemsShopItemsGetResponses, GetShopItemsShopItemsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetShopItemsShopItemsGetResponses, GetShopItemsShopItemsGetErrors, ThrowOnError>({ url: '/shop/items', ...options });

/**
 * Buy Shop Item
 *
 * Купити товар в магазині.
 */
export const buyShopItemShopBuyShopItemIdPost = <ThrowOnError extends boolean = false>(options: Options<BuyShopItemShopBuyShopItemIdPostData, ThrowOnError>): RequestResult<BuyShopItemShopBuyShopItemIdPostResponses, BuyShopItemShopBuyShopItemIdPostErrors, ThrowOnError> => (options.client ?? client).post<BuyShopItemShopBuyShopItemIdPostResponses, BuyShopItemShopBuyShopItemIdPostErrors, ThrowOnError>({
    url: '/shop/buy/{shop_item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Real Estate Catalog
 *
 * Отримати каталог нерухомості (будинків) з інформацією про знижку на перший будинок.
 */
export const getRealEstateCatalogRealEstateGet = <ThrowOnError extends boolean = false>(options?: Options<GetRealEstateCatalogRealEstateGetData, ThrowOnError>): RequestResult<GetRealEstateCatalogRealEstateGetResponses, GetRealEstateCatalogRealEstateGetErrors, ThrowOnError> => (options?.client ?? client).get<GetRealEstateCatalogRealEstateGetResponses, GetRealEstateCatalogRealEstateGetErrors, ThrowOnError>({ url: '/real-estate', ...options });

/**
 * Get All Map Objects
 *
 * Отримати всі об'єкти на карті (ділянки, будинки, міські будівлі тощо).
 */
export const getAllMapObjectsMapObjectsGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllMapObjectsMapObjectsGetData, ThrowOnError>): RequestResult<GetAllMapObjectsMapObjectsGetResponses, GetAllMapObjectsMapObjectsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetAllMapObjectsMapObjectsGetResponses, GetAllMapObjectsMapObjectsGetErrors, ThrowOnError>({ url: '/map-objects', ...options });

/**
 * Buy Map Object
 *
 * Purchase a map object (plot with house or parking_spot with vehicle).
 */
export const buyMapObjectMapObjectsMapObjectIdBuyPost = <ThrowOnError extends boolean = false>(options: Options<BuyMapObjectMapObjectsMapObjectIdBuyPostData, ThrowOnError>): RequestResult<BuyMapObjectMapObjectsMapObjectIdBuyPostResponses, BuyMapObjectMapObjectsMapObjectIdBuyPostErrors, ThrowOnError> => (options.client ?? client).post<BuyMapObjectMapObjectsMapObjectIdBuyPostResponses, BuyMapObjectMapObjectsMapObjectIdBuyPostErrors, ThrowOnError>({
    url: '/map-objects/{map_object_id}/buy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get House Abandonment
 *
 * Get abandonment info for a house. Owner only.
 * Returns days_since_visit and is_vip status.
 */
export const getHouseAbandonmentMapObjectsMapObjectIdAbandonmentGet = <ThrowOnError extends boolean = false>(options: Options<GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetData, ThrowOnError>): RequestResult<GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetResponses, GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetErrors, ThrowOnError> => (options.client ?? client).get<GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetResponses, GetHouseAbandonmentMapObjectsMapObjectIdAbandonmentGetErrors, ThrowOnError>({ url: '/map-objects/{map_object_id}/abandonment', ...options });

/**
 * Reset House Absence
 *
 * Reset the owner's absence counter by setting absence_reset_at to now. Owner only.
 */
export const resetHouseAbsenceMapObjectsMapObjectIdResetAbsencePost = <ThrowOnError extends boolean = false>(options: Options<ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostData, ThrowOnError>): RequestResult<ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostResponses, ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostErrors, ThrowOnError> => (options.client ?? client).post<ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostResponses, ResetHouseAbsenceMapObjectsMapObjectIdResetAbsencePostErrors, ThrowOnError>({ url: '/map-objects/{map_object_id}/reset-absence', ...options });

/**
 * Toggle Like
 *
 * Toggle like for a house (map object with type='house').
 *
 * If user hasn't liked the house, creates a like.
 * If user has already liked the house, removes the like.
 *
 * Returns:
 * JSON with is_liked (bool) and likes_count (int)
 */
export const toggleLikeMapObjectsMapObjectIdToggleLikePost = <ThrowOnError extends boolean = false>(options: Options<ToggleLikeMapObjectsMapObjectIdToggleLikePostData, ThrowOnError>): RequestResult<ToggleLikeMapObjectsMapObjectIdToggleLikePostResponses, ToggleLikeMapObjectsMapObjectIdToggleLikePostErrors, ThrowOnError> => (options.client ?? client).post<ToggleLikeMapObjectsMapObjectIdToggleLikePostResponses, ToggleLikeMapObjectsMapObjectIdToggleLikePostErrors, ThrowOnError>({ url: '/map-objects/{map_object_id}/toggle-like', ...options });

/**
 * Update House Info
 *
 * Оновити назву та опис будинку (тільки для власника).
 */
export const updateHouseInfoMapObjectsMapObjectIdHouseInfoPut = <ThrowOnError extends boolean = false>(options: Options<UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutData, ThrowOnError>): RequestResult<UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutResponses, UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutResponses, UpdateHouseInfoMapObjectsMapObjectIdHouseInfoPutErrors, ThrowOnError>({
    url: '/map-objects/{map_object_id}/house-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abandon House
 *
 * Abandon a house (convert it back to a free plot). Available only to house owners.
 */
export const abandonHouseMapObjectsMapObjectIdAbandonPost = <ThrowOnError extends boolean = false>(options: Options<AbandonHouseMapObjectsMapObjectIdAbandonPostData, ThrowOnError>): RequestResult<AbandonHouseMapObjectsMapObjectIdAbandonPostResponses, AbandonHouseMapObjectsMapObjectIdAbandonPostErrors, ThrowOnError> => (options.client ?? client).post<AbandonHouseMapObjectsMapObjectIdAbandonPostResponses, AbandonHouseMapObjectsMapObjectIdAbandonPostErrors, ThrowOnError>({ url: '/map-objects/{map_object_id}/abandon', ...options });

/**
 * Translate Map Object Message
 *
 * Translate the owner_message of a map object. Fetches text from DB — never from client.
 *
 * Target language is automatically detected from headers:
 * - X-User-Manually-Selected-Language (priority)
 * - Accept-Language (fallback)
 * - EN (default)
 *
 * Uses Redis caching to avoid redundant API calls.
 */
export const translateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePost = <ThrowOnError extends boolean = false>(options: Options<TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostData, ThrowOnError>): RequestResult<TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostResponses, TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostErrors, ThrowOnError> => (options.client ?? client).post<TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostResponses, TranslateMapObjectMessageMapObjectsMapObjectIdTranslateMessagePostErrors, ThrowOnError>({ url: '/map-objects/{map_object_id}/translate-message', ...options });

/**
 * Get Furniture Catalog
 *
 * Get all active furniture catalog items. Optional category and building_type filter.
 */
export const getFurnitureCatalogFurnitureCatalogGet = <ThrowOnError extends boolean = false>(options?: Options<GetFurnitureCatalogFurnitureCatalogGetData, ThrowOnError>): RequestResult<GetFurnitureCatalogFurnitureCatalogGetResponses, GetFurnitureCatalogFurnitureCatalogGetErrors, ThrowOnError> => (options?.client ?? client).get<GetFurnitureCatalogFurnitureCatalogGetResponses, GetFurnitureCatalogFurnitureCatalogGetErrors, ThrowOnError>({ url: '/furniture/catalog', ...options });

/**
 * Admin Update Furniture Catalog Tiles
 *
 * Update footprint_tiles and/or surface_tiles for a furniture catalog item (admin only).
 *
 * Each tile set is a list of [dx, dy] integer offsets relative to the object's center tile.
 * Use clear_footprint=true or clear_surface=true to reset to null (auto-estimate).
 */
export const adminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPut = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutData, ThrowOnError>): RequestResult<AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutResponses, AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutResponses, AdminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPutErrors, ThrowOnError>({
    url: '/admin/furniture-catalog/{catalog_id}/tiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get House Furniture
 *
 * Get all furniture for a house (inventory + placed). Any authenticated user can view.
 * Auto-creates a free bed if house has zero furniture and has an owner.
 */
export const getHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGet = <ThrowOnError extends boolean = false>(options: Options<GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetData, ThrowOnError>): RequestResult<GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetResponses, GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetErrors, ThrowOnError> => (options.client ?? client).get<GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetResponses, GetHouseFurnitureInteriorObjectsInteriorObjectIdFurnitureGetErrors, ThrowOnError>({ url: '/interior-objects/{interior_object_id}/furniture', ...options });

/**
 * Buy Furniture
 *
 * Buy furniture into a house or cityhall. Owner/mayor only.
 */
export const buyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPost = <ThrowOnError extends boolean = false>(options: Options<BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostData, ThrowOnError>): RequestResult<BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostResponses, BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostErrors, ThrowOnError> => (options.client ?? client).post<BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostResponses, BuyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPostErrors, ThrowOnError>({
    url: '/interior-objects/{interior_object_id}/furniture/buy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buy Furniture Bulk
 *
 * Buy multiple furniture items at once. Pearls items are bought atomically, stars items get one combined invoice.
 */
export const buyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPost = <ThrowOnError extends boolean = false>(options: Options<BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostData, ThrowOnError>): RequestResult<BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostResponses, BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostErrors, ThrowOnError> => (options.client ?? client).post<BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostResponses, BuyFurnitureBulkInteriorObjectsInteriorObjectIdFurnitureBuyBulkPostErrors, ThrowOnError>({
    url: '/interior-objects/{interior_object_id}/furniture/buy-bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Place Furniture
 *
 * Place furniture from inventory into a room. Owner/mayor only.
 */
export const placeFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePost = <ThrowOnError extends boolean = false>(options: Options<PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostData, ThrowOnError>): RequestResult<PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostResponses, PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostErrors, ThrowOnError> => (options.client ?? client).post<PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostResponses, PlaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPlacePostErrors, ThrowOnError>({
    url: '/interior-objects/{interior_object_id}/furniture/{furniture_id}/place',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Furniture
 *
 * Update furniture position or mirror state. Owner/mayor only. Furniture must be placed.
 */
export const updateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutData, ThrowOnError>): RequestResult<UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutResponses, UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutResponses, UpdateFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdPutErrors, ThrowOnError>({
    url: '/interior-objects/{interior_object_id}/furniture/{furniture_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unplace Furniture
 *
 * Remove furniture to inventory (unplace). Owner/mayor only.
 */
export const unplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePost = <ThrowOnError extends boolean = false>(options: Options<UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostData, ThrowOnError>): RequestResult<UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostResponses, UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostErrors, ThrowOnError> => (options.client ?? client).post<UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostResponses, UnplaceFurnitureInteriorObjectsInteriorObjectIdFurnitureFurnitureIdUnplacePostErrors, ThrowOnError>({ url: '/interior-objects/{interior_object_id}/furniture/{furniture_id}/unplace', ...options });

/**
 * Apply Furniture Layout
 *
 * Apply a batch of layout changes (move/mirror/place/unplace) atomically. Owner/mayor only.
 */
export const applyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPut = <ThrowOnError extends boolean = false>(options: Options<ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutData, ThrowOnError>): RequestResult<ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutResponses, ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutErrors, ThrowOnError> => (options.client ?? client).put<ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutResponses, ApplyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPutErrors, ThrowOnError>({
    url: '/interior-objects/{interior_object_id}/furniture-layout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Cobwebs
 *
 * Get all active cobwebs for a house. Any authenticated user can view.
 */
export const getCobwebsInteriorObjectsInteriorObjectIdCobwebsGet = <ThrowOnError extends boolean = false>(options: Options<GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetData, ThrowOnError>): RequestResult<GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetResponses, GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetErrors, ThrowOnError> => (options.client ?? client).get<GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetResponses, GetCobwebsInteriorObjectsInteriorObjectIdCobwebsGetErrors, ThrowOnError>({ url: '/interior-objects/{interior_object_id}/cobwebs', ...options });

/**
 * Delete Cobweb
 *
 * Sweep a cobweb — deletes the DB row. Any authenticated user can sweep.
 */
export const deleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteData, ThrowOnError>): RequestResult<DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteResponses, DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteResponses, DeleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDeleteErrors, ThrowOnError>({ url: '/interior-objects/{interior_object_id}/cobwebs/{cobweb_id}', ...options });

/**
 * Get User Public
 */
export const getUserPublicCalculateUserGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserPublicCalculateUserGetData, ThrowOnError>): RequestResult<GetUserPublicCalculateUserGetResponses, GetUserPublicCalculateUserGetErrors, ThrowOnError> => (options?.client ?? client).get<GetUserPublicCalculateUserGetResponses, GetUserPublicCalculateUserGetErrors, ThrowOnError>({ url: '/calculate-user', ...options });

/**
 * Get User Inventory
 *
 * Отримати інвентар користувача (тільки для власника).
 */
export const getUserInventoryUserInventoryGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserInventoryUserInventoryGetData, ThrowOnError>): RequestResult<GetUserInventoryUserInventoryGetResponses, GetUserInventoryUserInventoryGetErrors, ThrowOnError> => (options?.client ?? client).get<GetUserInventoryUserInventoryGetResponses, GetUserInventoryUserInventoryGetErrors, ThrowOnError>({ url: '/user/inventory', ...options });

/**
 * Activate User Item
 *
 * Активувати предмет з інвентаря користувача.
 */
export const activateUserItemUserInventoryUserItemIdActivatePost = <ThrowOnError extends boolean = false>(options: Options<ActivateUserItemUserInventoryUserItemIdActivatePostData, ThrowOnError>): RequestResult<ActivateUserItemUserInventoryUserItemIdActivatePostResponses, ActivateUserItemUserInventoryUserItemIdActivatePostErrors, ThrowOnError> => (options.client ?? client).post<ActivateUserItemUserInventoryUserItemIdActivatePostResponses, ActivateUserItemUserInventoryUserItemIdActivatePostErrors, ThrowOnError>({ url: '/user/inventory/{user_item_id}/activate', ...options });

/**
 * Create User Action
 *
 * Create unsafe user action (only actions from UNSAFE_ACTION_LIST are allowed).
 *
 * This endpoint allows creating user actions that can be triggered from frontend.
 * Only specific actions are allowed for security reasons.
 */
export const createUserActionUserActionsCreatePost = <ThrowOnError extends boolean = false>(options: Options<CreateUserActionUserActionsCreatePostData, ThrowOnError>): RequestResult<CreateUserActionUserActionsCreatePostResponses, CreateUserActionUserActionsCreatePostErrors, ThrowOnError> => (options.client ?? client).post<CreateUserActionUserActionsCreatePostResponses, CreateUserActionUserActionsCreatePostErrors, ThrowOnError>({
    url: '/user/actions/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim Onboarding Reward
 *
 * One-time onboarding reward: +1M pearls + 1M EXP after completing tutorial.
 */
export const claimOnboardingRewardUserClaimOnboardingRewardPost = <ThrowOnError extends boolean = false>(options?: Options<ClaimOnboardingRewardUserClaimOnboardingRewardPostData, ThrowOnError>): RequestResult<ClaimOnboardingRewardUserClaimOnboardingRewardPostResponses, ClaimOnboardingRewardUserClaimOnboardingRewardPostErrors, ThrowOnError> => (options?.client ?? client).post<ClaimOnboardingRewardUserClaimOnboardingRewardPostResponses, ClaimOnboardingRewardUserClaimOnboardingRewardPostErrors, ThrowOnError>({ url: '/user/claim-onboarding-reward', ...options });

/**
 * Verify Notifications
 *
 * The player allowed the bot to message them: send a real thank-you message.
 * Delivered → recorded and, the first time, rewarded (by `source`).
 */
export const verifyNotificationsUserNotificationsVerifyPost = <ThrowOnError extends boolean = false>(options: Options<VerifyNotificationsUserNotificationsVerifyPostData, ThrowOnError>): RequestResult<VerifyNotificationsUserNotificationsVerifyPostResponses, VerifyNotificationsUserNotificationsVerifyPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyNotificationsUserNotificationsVerifyPostResponses, VerifyNotificationsUserNotificationsVerifyPostErrors, ThrowOnError>({
    url: '/user/notifications/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Comeback Replay
 *
 * Back after a long absence: restart the tutorial (its reward is paid again at the end).
 */
export const comebackReplayUserComebackReplayPost = <ThrowOnError extends boolean = false>(options?: Options<ComebackReplayUserComebackReplayPostData, ThrowOnError>): RequestResult<ComebackReplayUserComebackReplayPostResponses, ComebackReplayUserComebackReplayPostErrors, ThrowOnError> => (options?.client ?? client).post<ComebackReplayUserComebackReplayPostResponses, ComebackReplayUserComebackReplayPostErrors, ThrowOnError>({ url: '/user/comeback/replay', ...options });

/**
 * Comeback Decline
 *
 * Back after a long absence: the player does not want to replay the tutorial.
 */
export const comebackDeclineUserComebackDeclinePost = <ThrowOnError extends boolean = false>(options?: Options<ComebackDeclineUserComebackDeclinePostData, ThrowOnError>): RequestResult<ComebackDeclineUserComebackDeclinePostResponses, ComebackDeclineUserComebackDeclinePostErrors, ThrowOnError> => (options?.client ?? client).post<ComebackDeclineUserComebackDeclinePostResponses, ComebackDeclineUserComebackDeclinePostErrors, ThrowOnError>({ url: '/user/comeback/decline', ...options });

/**
 * Delete User Onboarding State
 */
export const deleteUserOnboardingStateUserOnboardingStateDelete = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserOnboardingStateUserOnboardingStateDeleteData, ThrowOnError>): RequestResult<DeleteUserOnboardingStateUserOnboardingStateDeleteResponses, DeleteUserOnboardingStateUserOnboardingStateDeleteErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteUserOnboardingStateUserOnboardingStateDeleteResponses, DeleteUserOnboardingStateUserOnboardingStateDeleteErrors, ThrowOnError>({ url: '/user/onboarding-state', ...options });

/**
 * Get User Onboarding State
 *
 * Онбординг: user_onboarding_kv (append INSERT; GET — останнє значення на ключ).
 *
 * X-Session-Id identifies the app launch; a new one restarts unfinished onboarding.
 */
export const getUserOnboardingStateUserOnboardingStateGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserOnboardingStateUserOnboardingStateGetData, ThrowOnError>): RequestResult<GetUserOnboardingStateUserOnboardingStateGetResponses, GetUserOnboardingStateUserOnboardingStateGetErrors, ThrowOnError> => (options?.client ?? client).get<GetUserOnboardingStateUserOnboardingStateGetResponses, GetUserOnboardingStateUserOnboardingStateGetErrors, ThrowOnError>({ url: '/user/onboarding-state', ...options });

/**
 * Patch User Onboarding State
 */
export const patchUserOnboardingStateUserOnboardingStatePatch = <ThrowOnError extends boolean = false>(options: Options<PatchUserOnboardingStateUserOnboardingStatePatchData, ThrowOnError>): RequestResult<PatchUserOnboardingStateUserOnboardingStatePatchResponses, PatchUserOnboardingStateUserOnboardingStatePatchErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserOnboardingStateUserOnboardingStatePatchResponses, PatchUserOnboardingStateUserOnboardingStatePatchErrors, ThrowOnError>({
    url: '/user/onboarding-state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Election Dialog State
 *
 * Чи показувати діалог виборів на мапі (не змішувати з /cityhall/state).
 */
export const getUserElectionDialogStateUserElectionDialogGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserElectionDialogStateUserElectionDialogGetData, ThrowOnError>): RequestResult<GetUserElectionDialogStateUserElectionDialogGetResponses, GetUserElectionDialogStateUserElectionDialogGetErrors, ThrowOnError> => (options?.client ?? client).get<GetUserElectionDialogStateUserElectionDialogGetResponses, GetUserElectionDialogStateUserElectionDialogGetErrors, ThrowOnError>({ url: '/user/election-dialog', ...options });

/**
 * Delete User Popup State
 */
export const deleteUserPopupStateUserPopupStateDelete = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserPopupStateUserPopupStateDeleteData, ThrowOnError>): RequestResult<DeleteUserPopupStateUserPopupStateDeleteResponses, DeleteUserPopupStateUserPopupStateDeleteErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteUserPopupStateUserPopupStateDeleteResponses, DeleteUserPopupStateUserPopupStateDeleteErrors, ThrowOnError>({ url: '/user/popup-state', ...options });

/**
 * Get User Popup State
 */
export const getUserPopupStateUserPopupStateGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserPopupStateUserPopupStateGetData, ThrowOnError>): RequestResult<GetUserPopupStateUserPopupStateGetResponses, GetUserPopupStateUserPopupStateGetErrors, ThrowOnError> => (options?.client ?? client).get<GetUserPopupStateUserPopupStateGetResponses, GetUserPopupStateUserPopupStateGetErrors, ThrowOnError>({ url: '/user/popup-state', ...options });

/**
 * Patch User Popup State
 */
export const patchUserPopupStateUserPopupStatePatch = <ThrowOnError extends boolean = false>(options: Options<PatchUserPopupStateUserPopupStatePatchData, ThrowOnError>): RequestResult<PatchUserPopupStateUserPopupStatePatchResponses, PatchUserPopupStateUserPopupStatePatchErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserPopupStateUserPopupStatePatchResponses, PatchUserPopupStateUserPopupStatePatchErrors, ThrowOnError>({
    url: '/user/popup-state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Quest Progress
 *
 * Get progress for user quests.
 *
 * Returns current progress (current_count/target_count) for each objective
 * in the specified user quests.
 */
export const getQuestProgressQuestsGetProgressPost = <ThrowOnError extends boolean = false>(options: Options<GetQuestProgressQuestsGetProgressPostData, ThrowOnError>): RequestResult<GetQuestProgressQuestsGetProgressPostResponses, GetQuestProgressQuestsGetProgressPostErrors, ThrowOnError> => (options.client ?? client).post<GetQuestProgressQuestsGetProgressPostResponses, GetQuestProgressQuestsGetProgressPostErrors, ThrowOnError>({
    url: '/quests/get-progress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify External Quests
 *
 * Verify external quest objectives (subscription, chat membership, partner miniapp) and update completion status.
 *
 * This endpoint performs external API checks for quests that require verification via:
 * - Telegram Bot API (for group/channel subscription and chat membership)
 * - Partner API (for miniapp usage)
 *
 * If all objectives are completed, the quest's `is_finished` status is automatically updated.
 */
export const verifyExternalQuestsUserQuestsVerifyExternalQuestsPost = <ThrowOnError extends boolean = false>(options: Options<VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostData, ThrowOnError>): RequestResult<VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostResponses, VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostResponses, VerifyExternalQuestsUserQuestsVerifyExternalQuestsPostErrors, ThrowOnError>({
    url: '/user/quests/verify-external-quests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign And Get Daily Quests
 *
 * Assign and get daily quests for today (UTC) with progress.
 *
 * Automatically assigns daily quests if user doesn't have any for today.
 * Automatically updates quest completion status before returning results.
 * Returns all daily quests WITH progress information in a single response.
 *
 * This endpoint:
 * - Automatically assigns quests if user has none for today
 * - Automatically updates quest completion status (is_finished) before returning
 * - Returns quests with full progress (current_count/target_count for each objective)
 * - Combines quest data and progress in a single response
 *
 * Frontend only needs to call this one endpoint - no separate assignment, status update, or progress calls needed.
 */
export const assignAndGetDailyQuestsUserQuestsDailyAssignAndGetGet = <ThrowOnError extends boolean = false>(options?: Options<AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetData, ThrowOnError>): RequestResult<AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetResponses, AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetErrors, ThrowOnError> => (options?.client ?? client).get<AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetResponses, AssignAndGetDailyQuestsUserQuestsDailyAssignAndGetGetErrors, ThrowOnError>({ url: '/user/quests/daily/assign-and-get', ...options });

/**
 * Assign And Get Hourly Quests
 *
 * Assign and get hourly quests for current hour (UTC) with progress.
 *
 * Automatically assigns hourly quests if user doesn't have any for current hour.
 * Automatically updates quest completion status before returning results.
 * Returns all hourly quests WITH progress information in a single response.
 *
 * This endpoint:
 * - Automatically assigns quests if user has none for current hour
 * - Automatically updates quest completion status (is_finished) before returning
 * - Returns quests with full progress (current_count/target_count for each objective)
 * - Combines quest data and progress in a single response
 *
 * Frontend only needs to call this one endpoint - no separate assignment, status update, or progress calls needed.
 */
export const assignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGet = <ThrowOnError extends boolean = false>(options?: Options<AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetData, ThrowOnError>): RequestResult<AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetResponses, AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetErrors, ThrowOnError> => (options?.client ?? client).get<AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetResponses, AssignAndGetHourlyQuestsUserQuestsHourlyAssignAndGetGetErrors, ThrowOnError>({ url: '/user/quests/hourly/assign-and-get', ...options });

/**
 * Assign And Get Marketing Quests
 *
 * Assign and get marketing quests with progress.
 *
 * Automatically assigns marketing quests if user doesn't have any.
 * Automatically updates quest completion status before returning results.
 * Returns all marketing quests WITH progress information in a single response.
 *
 * This endpoint:
 * - Automatically assigns quests if user has none
 * - Automatically updates quest completion status (is_finished) before returning
 * - Returns quests with full progress (current_count/target_count for each objective)
 * - Combines quest data and progress in a single response
 * - Marketing quests are not filtered by date (unlike daily quests)
 *
 * Frontend only needs to call this one endpoint - no separate assignment, status update, or progress calls needed.
 */
export const assignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGet = <ThrowOnError extends boolean = false>(options?: Options<AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetData, ThrowOnError>): RequestResult<AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetResponses, AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetErrors, ThrowOnError> => (options?.client ?? client).get<AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetResponses, AssignAndGetMarketingQuestsUserQuestsMarketingAssignAndGetGetErrors, ThrowOnError>({ url: '/user/quests/marketing/assign-and-get', ...options });

/**
 * Assign And Get All Quests
 *
 * Assign and get all quest types (daily, hourly, marketing, main) with progress.
 *
 * This is a unified endpoint that combines:
 * - Daily quests (resets at midnight UTC)
 * - Hourly quests (resets at start of each hour UTC)
 * - Marketing quests (no time-based reset)
 * - Main quests (no time-based reset)
 *
 * Automatically assigns quests if user doesn't have any for the current period.
 * Automatically updates quest completion status before returning results.
 * Returns all quests WITH progress information grouped by type.
 */
export const assignAndGetAllQuestsUserQuestsAssignAndGetGet = <ThrowOnError extends boolean = false>(options?: Options<AssignAndGetAllQuestsUserQuestsAssignAndGetGetData, ThrowOnError>): RequestResult<AssignAndGetAllQuestsUserQuestsAssignAndGetGetResponses, AssignAndGetAllQuestsUserQuestsAssignAndGetGetErrors, ThrowOnError> => (options?.client ?? client).get<AssignAndGetAllQuestsUserQuestsAssignAndGetGetResponses, AssignAndGetAllQuestsUserQuestsAssignAndGetGetErrors, ThrowOnError>({ url: '/user/quests/assign-and-get', ...options });

/**
 * Claim Quest Reward
 *
 * Claim reward for completed quest.
 *
 * Creates UserItem with reward from quest.reward_item_id and adds it to user's inventory.
 * Quest must be finished (is_finished = True) and reward must not be claimed yet.
 * Returns the created UserItem ID.
 */
export const claimQuestRewardUserQuestsClaimRewardPost = <ThrowOnError extends boolean = false>(options: Options<ClaimQuestRewardUserQuestsClaimRewardPostData, ThrowOnError>): RequestResult<ClaimQuestRewardUserQuestsClaimRewardPostResponses, ClaimQuestRewardUserQuestsClaimRewardPostErrors, ThrowOnError> => (options.client ?? client).post<ClaimQuestRewardUserQuestsClaimRewardPostResponses, ClaimQuestRewardUserQuestsClaimRewardPostErrors, ThrowOnError>({
    url: '/user/quests/claim-reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Map Object
 *
 * Видалити будь-який MapObject за ID (тільки для адмінів).
 */
export const deleteMapObjectAdminMapObjectsMapObjectIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMapObjectAdminMapObjectsMapObjectIdDeleteData, ThrowOnError>): RequestResult<DeleteMapObjectAdminMapObjectsMapObjectIdDeleteResponses, DeleteMapObjectAdminMapObjectsMapObjectIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMapObjectAdminMapObjectsMapObjectIdDeleteResponses, DeleteMapObjectAdminMapObjectsMapObjectIdDeleteErrors, ThrowOnError>({ url: '/admin/map-objects/{map_object_id}', ...options });

/**
 * Update Map Object
 *
 * Оновити об'єкт на карті (тільки для адмінів).
 */
export const updateMapObjectAdminMapObjectsMapObjectIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateMapObjectAdminMapObjectsMapObjectIdPutData, ThrowOnError>): RequestResult<UpdateMapObjectAdminMapObjectsMapObjectIdPutResponses, UpdateMapObjectAdminMapObjectsMapObjectIdPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateMapObjectAdminMapObjectsMapObjectIdPutResponses, UpdateMapObjectAdminMapObjectsMapObjectIdPutErrors, ThrowOnError>({
    url: '/admin/map-objects/{map_object_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Update Map Object Coordinates
 *
 * Update map object coordinates (admin-only).
 */
export const adminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPut = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutData, ThrowOnError>): RequestResult<AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutResponses, AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutResponses, AdminUpdateMapObjectCoordinatesAdminMapObjectsMapObjectIdCoordinatesPutErrors, ThrowOnError>({
    url: '/admin/map-objects/{map_object_id}/coordinates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Plot
 *
 * Create a new plot or any map object (admin only). Now accepts optional type parameter.
 */
export const createPlotAdminPlotsPost = <ThrowOnError extends boolean = false>(options: Options<CreatePlotAdminPlotsPostData, ThrowOnError>): RequestResult<CreatePlotAdminPlotsPostResponses, CreatePlotAdminPlotsPostErrors, ThrowOnError> => (options.client ?? client).post<CreatePlotAdminPlotsPostResponses, CreatePlotAdminPlotsPostErrors, ThrowOnError>({
    url: '/admin/plots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Map Object Types
 *
 * Get list of available map object types (admin only).
 */
export const getMapObjectTypesAdminMapObjectsTypesGet = <ThrowOnError extends boolean = false>(options?: Options<GetMapObjectTypesAdminMapObjectsTypesGetData, ThrowOnError>): RequestResult<GetMapObjectTypesAdminMapObjectsTypesGetResponses, GetMapObjectTypesAdminMapObjectsTypesGetErrors, ThrowOnError> => (options?.client ?? client).get<GetMapObjectTypesAdminMapObjectsTypesGetResponses, GetMapObjectTypesAdminMapObjectsTypesGetErrors, ThrowOnError>({ url: '/admin/map-objects/types', ...options });

/**
 * Admin Complete Election
 *
 * Дострокове завершення виборів (тільки для адмінів).
 *
 * Завершує поточні вибори, визначає переможця (кандидат з найбільшою кількістю голосів)
 * та призначає його мером на 60 днів. Якщо вибори не активні або немає кандидатів/голосів,
 * повертає помилку.
 */
export const adminCompleteElectionAdminElectionsCompletePost = <ThrowOnError extends boolean = false>(options?: Options<AdminCompleteElectionAdminElectionsCompletePostData, ThrowOnError>): RequestResult<AdminCompleteElectionAdminElectionsCompletePostResponses, AdminCompleteElectionAdminElectionsCompletePostErrors, ThrowOnError> => (options?.client ?? client).post<AdminCompleteElectionAdminElectionsCompletePostResponses, AdminCompleteElectionAdminElectionsCompletePostErrors, ThrowOnError>({ url: '/admin/elections/complete', ...options });

/**
 * Admin Remove Mayor
 *
 * Зняти поточного мера з посади (тільки для адмінів).
 *
 * Знімає поточного мера з посади, очищає посаду та історію виборів.
 * Після цього інші користувачі мають можливість одразу подати кандидатуру.
 */
export const adminRemoveMayorAdminElectionsRemoveMayorPost = <ThrowOnError extends boolean = false>(options?: Options<AdminRemoveMayorAdminElectionsRemoveMayorPostData, ThrowOnError>): RequestResult<AdminRemoveMayorAdminElectionsRemoveMayorPostResponses, AdminRemoveMayorAdminElectionsRemoveMayorPostErrors, ThrowOnError> => (options?.client ?? client).post<AdminRemoveMayorAdminElectionsRemoveMayorPostResponses, AdminRemoveMayorAdminElectionsRemoveMayorPostErrors, ThrowOnError>({ url: '/admin/elections/remove-mayor', ...options });

/**
 * Ping
 */
export const pingPingGet = <ThrowOnError extends boolean = false>(options?: Options<PingPingGetData, ThrowOnError>): RequestResult<PingPingGetResponses, PingPingGetErrors, ThrowOnError> => (options?.client ?? client).get<PingPingGetResponses, PingPingGetErrors, ThrowOnError>({ url: '/ping', ...options });

/**
 * Trigger Error
 */
export const triggerErrorSentryCheckGet = <ThrowOnError extends boolean = false>(options?: Options<TriggerErrorSentryCheckGetData, ThrowOnError>): RequestResult<TriggerErrorSentryCheckGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TriggerErrorSentryCheckGetResponses, unknown, ThrowOnError>({ url: '/sentry-check', ...options });

/**
 * Proxy Avatar
 *
 * Proxy Telegram avatar images with CORS headers for WebGL/PIXI usage.
 */
export const proxyAvatarProxyAvatarGet = <ThrowOnError extends boolean = false>(options: Options<ProxyAvatarProxyAvatarGetData, ThrowOnError>): RequestResult<ProxyAvatarProxyAvatarGetResponses, ProxyAvatarProxyAvatarGetErrors, ThrowOnError> => (options.client ?? client).get<ProxyAvatarProxyAvatarGetResponses, ProxyAvatarProxyAvatarGetErrors, ThrowOnError>({ url: '/proxy/avatar', ...options });

/**
 * Tap
 *
 * Record a tap into the Redis buffer (RPUSH). Empty 200 body.
 *
 * Production frontend usually hits the Cloudflare Worker instead; this route
 * remains for local dev (vite proxy /api/tap) and any direct backend callers.
 * Flush is handled by arq task_flush_taps. Payload format: ``user_id|timestamp``.
 */
export const tapTapPost = <ThrowOnError extends boolean = false>(options?: Options<TapTapPostData, ThrowOnError>): RequestResult<TapTapPostResponses, TapTapPostErrors, ThrowOnError> => (options?.client ?? client).post<TapTapPostResponses, TapTapPostErrors, ThrowOnError>({ url: '/tap', ...options });

/**
 * Create Invoice
 *
 * Створити invoice link для оплати через Telegram Stars (універсальний для real_estate та shop_item).
 */
export const createInvoiceTelegramCreateInvoicePost = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceTelegramCreateInvoicePostData, ThrowOnError>): RequestResult<CreateInvoiceTelegramCreateInvoicePostResponses, CreateInvoiceTelegramCreateInvoicePostErrors, ThrowOnError> => (options.client ?? client).post<CreateInvoiceTelegramCreateInvoicePostResponses, CreateInvoiceTelegramCreateInvoicePostErrors, ThrowOnError>({
    url: '/telegram/create-invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Firefly Ack Endpoint
 *
 * Client confirms it received and rendered a firefly. Logs to viewport_sharing.log.
 */
export const fireflyAckEndpointDebugFireflyAckPost = <ThrowOnError extends boolean = false>(options: Options<FireflyAckEndpointDebugFireflyAckPostData, ThrowOnError>): RequestResult<FireflyAckEndpointDebugFireflyAckPostResponses, FireflyAckEndpointDebugFireflyAckPostErrors, ThrowOnError> => (options.client ?? client).post<FireflyAckEndpointDebugFireflyAckPostResponses, FireflyAckEndpointDebugFireflyAckPostErrors, ThrowOnError>({
    url: '/debug/firefly-ack',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Firefly State Endpoint
 *
 * Dump current firefly Redis state for a room.
 */
export const fireflyStateEndpointDebugFireflyStateGet = <ThrowOnError extends boolean = false>(options?: Options<FireflyStateEndpointDebugFireflyStateGetData, ThrowOnError>): RequestResult<FireflyStateEndpointDebugFireflyStateGetResponses, FireflyStateEndpointDebugFireflyStateGetErrors, ThrowOnError> => (options?.client ?? client).get<FireflyStateEndpointDebugFireflyStateGetResponses, FireflyStateEndpointDebugFireflyStateGetErrors, ThrowOnError>({ url: '/debug/firefly-state', ...options });

/**
 * Get Cursor User Info
 *
 * Return public info for a cursor emoji popup (no auth required — all data is public).
 */
export const getCursorUserInfoCursorUserInfoTgUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCursorUserInfoCursorUserInfoTgUserIdGetData, ThrowOnError>): RequestResult<GetCursorUserInfoCursorUserInfoTgUserIdGetResponses, GetCursorUserInfoCursorUserInfoTgUserIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCursorUserInfoCursorUserInfoTgUserIdGetResponses, GetCursorUserInfoCursorUserInfoTgUserIdGetErrors, ThrowOnError>({ url: '/cursor-user-info/{tg_user_id}', ...options });

/**
 * Debug Taskad Log
 */
export const debugTaskadLogDebugTaskadLogPost = <ThrowOnError extends boolean = false>(options: Options<DebugTaskadLogDebugTaskadLogPostData, ThrowOnError>): RequestResult<DebugTaskadLogDebugTaskadLogPostResponses, DebugTaskadLogDebugTaskadLogPostErrors, ThrowOnError> => (options.client ?? client).post<DebugTaskadLogDebugTaskadLogPostResponses, DebugTaskadLogDebugTaskadLogPostErrors, ThrowOnError>({
    url: '/debug/taskad-log',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save Wallet
 *
 * Save user's TON wallet address (called on TonConnect).
 */
export const saveWalletMarketplaceSaveWalletPost = <ThrowOnError extends boolean = false>(options: Options<SaveWalletMarketplaceSaveWalletPostData, ThrowOnError>): RequestResult<SaveWalletMarketplaceSaveWalletPostResponses, SaveWalletMarketplaceSaveWalletPostErrors, ThrowOnError> => (options.client ?? client).post<SaveWalletMarketplaceSaveWalletPostResponses, SaveWalletMarketplaceSaveWalletPostErrors, ThrowOnError>({
    url: '/marketplace/save-wallet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Rate
 *
 * Get current TON/USDT rate.
 */
export const getRateMarketplaceRateGet = <ThrowOnError extends boolean = false>(options?: Options<GetRateMarketplaceRateGetData, ThrowOnError>): RequestResult<GetRateMarketplaceRateGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRateMarketplaceRateGetResponses, unknown, ThrowOnError>({ url: '/marketplace/rate', ...options });

/**
 * Get Listings
 *
 * Get all active marketplace listings.
 */
export const getListingsMarketplaceListingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetListingsMarketplaceListingsGetData, ThrowOnError>): RequestResult<GetListingsMarketplaceListingsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetListingsMarketplaceListingsGetResponses, unknown, ThrowOnError>({ url: '/marketplace/listings', ...options });

/**
 * List House
 *
 * Put a house for sale on the marketplace.
 */
export const listHouseMarketplaceListPost = <ThrowOnError extends boolean = false>(options: Options<ListHouseMarketplaceListPostData, ThrowOnError>): RequestResult<ListHouseMarketplaceListPostResponses, ListHouseMarketplaceListPostErrors, ThrowOnError> => (options.client ?? client).post<ListHouseMarketplaceListPostResponses, ListHouseMarketplaceListPostErrors, ThrowOnError>({
    url: '/marketplace/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Listing
 *
 * Cancel a marketplace listing.
 */
export const cancelListingMarketplaceCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelListingMarketplaceCancelPostData, ThrowOnError>): RequestResult<CancelListingMarketplaceCancelPostResponses, CancelListingMarketplaceCancelPostErrors, ThrowOnError> => (options.client ?? client).post<CancelListingMarketplaceCancelPostResponses, CancelListingMarketplaceCancelPostErrors, ThrowOnError>({
    url: '/marketplace/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Balances
 *
 * Get user's marketplace balances.
 */
export const getBalancesMarketplaceMyBalancesGet = <ThrowOnError extends boolean = false>(options?: Options<GetBalancesMarketplaceMyBalancesGetData, ThrowOnError>): RequestResult<GetBalancesMarketplaceMyBalancesGetResponses, GetBalancesMarketplaceMyBalancesGetErrors, ThrowOnError> => (options?.client ?? client).get<GetBalancesMarketplaceMyBalancesGetResponses, GetBalancesMarketplaceMyBalancesGetErrors, ThrowOnError>({ url: '/marketplace/my-balances', ...options });

/**
 * Estimate Gas
 *
 * Estimate gas fee for TON or USDT withdrawal.
 */
export const estimateGasMarketplaceEstimateGasGet = <ThrowOnError extends boolean = false>(options?: Options<EstimateGasMarketplaceEstimateGasGetData, ThrowOnError>): RequestResult<EstimateGasMarketplaceEstimateGasGetResponses, EstimateGasMarketplaceEstimateGasGetErrors, ThrowOnError> => (options?.client ?? client).get<EstimateGasMarketplaceEstimateGasGetResponses, EstimateGasMarketplaceEstimateGasGetErrors, ThrowOnError>({ url: '/marketplace/estimate-gas', ...options });

/**
 * Request Withdraw
 *
 * Queue a withdrawal request. Actual processing runs via arq task_process_withdrawals.
 */
export const requestWithdrawMarketplaceWithdrawPost = <ThrowOnError extends boolean = false>(options: Options<RequestWithdrawMarketplaceWithdrawPostData, ThrowOnError>): RequestResult<RequestWithdrawMarketplaceWithdrawPostResponses, RequestWithdrawMarketplaceWithdrawPostErrors, ThrowOnError> => (options.client ?? client).post<RequestWithdrawMarketplaceWithdrawPostResponses, RequestWithdrawMarketplaceWithdrawPostErrors, ThrowOnError>({
    url: '/marketplace/withdraw',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Listing For House
 *
 * Get active listing for a specific house.
 */
export const getListingForHouseMarketplaceListingMapObjectIdGet = <ThrowOnError extends boolean = false>(options: Options<GetListingForHouseMarketplaceListingMapObjectIdGetData, ThrowOnError>): RequestResult<GetListingForHouseMarketplaceListingMapObjectIdGetResponses, GetListingForHouseMarketplaceListingMapObjectIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetListingForHouseMarketplaceListingMapObjectIdGetResponses, GetListingForHouseMarketplaceListingMapObjectIdGetErrors, ThrowOnError>({ url: '/marketplace/listing/{map_object_id}', ...options });

/**
 * Get Referral Info
 *
 * Get referral information for the current user.
 */
export const getReferralInfoReferralInfoGet = <ThrowOnError extends boolean = false>(options?: Options<GetReferralInfoReferralInfoGetData, ThrowOnError>): RequestResult<GetReferralInfoReferralInfoGetResponses, GetReferralInfoReferralInfoGetErrors, ThrowOnError> => (options?.client ?? client).get<GetReferralInfoReferralInfoGetResponses, GetReferralInfoReferralInfoGetErrors, ThrowOnError>({ url: '/referral/info', ...options });

/**
 * Get Referral Stats
 *
 * Get comprehensive referral statistics for the current user.
 */
export const getReferralStatsReferralStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetReferralStatsReferralStatsGetData, ThrowOnError>): RequestResult<GetReferralStatsReferralStatsGetResponses, GetReferralStatsReferralStatsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetReferralStatsReferralStatsGetResponses, GetReferralStatsReferralStatsGetErrors, ThrowOnError>({ url: '/referral/stats', ...options });

/**
 * Telegram Webhook
 *
 * Webhook endpoint for Telegram payments. Validates secret token and processes pre_checkout_query and successful payments.
 */
export const telegramWebhookTelegramWebhookPost = <ThrowOnError extends boolean = false>(options?: Options<TelegramWebhookTelegramWebhookPostData, ThrowOnError>): RequestResult<TelegramWebhookTelegramWebhookPostResponses, TelegramWebhookTelegramWebhookPostErrors, ThrowOnError> => (options?.client ?? client).post<TelegramWebhookTelegramWebhookPostResponses, TelegramWebhookTelegramWebhookPostErrors, ThrowOnError>({ url: '/telegram/webhook', ...options });

/**
 * Check User
 *
 * Check if a user exists in the system.
 *
 * API key can be provided either in:
 * - Request body (api_key field)
 * - Header (X-API-Key)
 *
 * Header takes priority if both are provided.
 */
export const checkUserPartnerCheckUserPost = <ThrowOnError extends boolean = false>(options: Options<CheckUserPartnerCheckUserPostData, ThrowOnError>): RequestResult<CheckUserPartnerCheckUserPostResponses, CheckUserPartnerCheckUserPostErrors, ThrowOnError> => (options.client ?? client).post<CheckUserPartnerCheckUserPostResponses, CheckUserPartnerCheckUserPostErrors, ThrowOnError>({
    url: '/partner/check-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
